import { AiFillMedicineBox, AiOutlineInfoCircle } from 'react-icons/ai';
import { BiBlock, BiLogOut, BiRename, BiSelectMultiple } from 'react-icons/bi';
import {
  BsDatabaseAdd,
  BsHospital,
  BsJournalMedical,
  BsPeople,
  BsTrashFill,
  BsUiChecks,
  BsXCircleFill
} from 'react-icons/bs';
import { CiPaperplane } from 'react-icons/ci';
import {
  FaArrowDown,
  FaArrowLeft,
  FaArrowsAltV,
  FaArrowUp,
  FaBars,
  FaChartBar,
  FaCheck,
  FaCheckCircle,
  FaCheckSquare,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
  FaClock,
  FaClone,
  FaCopy,
  FaDotCircle,
  FaEye,
  FaFileDownload,
  FaFilter,
  FaHistory,
  FaHospital,
  FaList,
  FaMicrophoneAlt,
  FaPencilAlt,
  FaQuestion,
  FaRegCircle,
  FaRegQuestionCircle,
  FaSave,
  FaStethoscope,
  FaTable,
  FaUndo,
  FaUserAltSlash,
  FaUserCheck,
  FaUserEdit
} from 'react-icons/fa';
import {
  FaArrowRotateLeft,
  FaCircleCheck,
  FaFileArrowUp,
  FaMagnifyingGlass,
  FaPlus,
  FaRegCircleCheck,
  FaTimeline,
  FaUsersGear,
  FaWpforms
} from 'react-icons/fa6';
import { FiUser } from 'react-icons/fi';
import { GiMedicines } from 'react-icons/gi';
import { GoSingleSelect } from 'react-icons/go';
import { GrSchedule } from 'react-icons/gr';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import {
  HiMiniArrowRightCircle,
  HiMiniCog8Tooth,
  HiMiniPencilSquare,
  HiMiniShieldCheck
} from 'react-icons/hi2';
import { ImStatsBars2 } from 'react-icons/im';
import { IoLogoBuffer, IoMdRemoveCircleOutline } from 'react-icons/io';
import { IoPeople, IoPerson, IoPricetags, IoReload } from 'react-icons/io5';
import { LiaUserInjuredSolid } from 'react-icons/lia';
import {
  LuFileCheck,
  LuHeartHandshake,
  LuNetwork
} from 'react-icons/lu';
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdClose,
  MdHealthAndSafety,
  MdNewReleases,
  MdOutlineAssignmentTurnedIn,
  MdOutlineCellTower,
  MdOutlineEmail,
  MdOutlineReadMore,
  MdOutlineSecurity,
  MdPregnantWoman
} from 'react-icons/md';
import {
  PiExcludeFill,
  PiFilesFill,
  PiNewspaperClippingBold,
  PiUploadBold
} from 'react-icons/pi';
import {
  RiAlertFill,
  RiFileHistoryLine,
  RiHotelBedLine,
  RiLockPasswordLine,
  RiUserAddFill,
  RiUserFollowFill,
  RiUserFollowLine
} from 'react-icons/ri';
import { TbArrowsRandom, TbTriangleSquareCircleFilled } from 'react-icons/tb';
import { TiCancel } from 'react-icons/ti';
import { VscGraph } from 'react-icons/vsc';

export const ICONS = {
  arrowRotateLeft: FaArrowRotateLeft,
  aiFillMedicineBox: AiFillMedicineBox,
  journalMedical: BsJournalMedical,
  alertFill: RiAlertFill,
  app_logo: PiExcludeFill,
  arrowDown: FaArrowDown,
  arrowLeft: FaArrowLeft,
  arrowsRandom: TbArrowsRandom,
  arrowUp: FaArrowUp,
  arrowVerticalBi: FaArrowsAltV,
  assignmentTurnedIn: MdOutlineAssignmentTurnedIn,
  bars: FaBars,
  bedPulse: RiHotelBedLine,
  biSelectMultiple: BiSelectMultiple,
  block: BiBlock,
  bsDatabaseAdd: BsDatabaseAdd,
  bsHospital: BsHospital,
  BsPeople: BsPeople,
  calendar: GrSchedule,
  cancel: TiCancel,
  chartBar: FaChartBar,
  check: FaCheck,
  checkBox: MdCheckBox,
  checkBoxOutlineBlank: MdCheckBoxOutlineBlank,
  checkCircle: FaCheckCircle,
  checkSquare: FaCheckSquare,
  chevronDown: FaChevronDown,
  chevronLeft: FaChevronLeft,
  chevronRight: FaChevronRight,
  chevronUp: FaChevronUp,
  ciPaperplane: CiPaperplane,
  circle: FaRegCircle,
  clock: FaClock,
  clone: FaClone,
  close: MdClose,
  copy: FaCopy,
  dot: FaDotCircle,
  emailOutline: MdOutlineEmail,
  eye: FaEye,
  stethoscope: FaStethoscope,
  fileArrowUp: FaFileArrowUp,
  fileCheck: LuFileCheck,
  fileDownload: FaFileDownload,
  files: PiFilesFill,
  filledCheck: FaCircleCheck,
  filter: FaFilter,
  giMedicines: GiMedicines,
  goSingleSelect: GoSingleSelect,
  hiMiniArrowRightCircle: HiMiniArrowRightCircle,
  hiMiniCog8Tooth: HiMiniCog8Tooth,
  hiMiniPencilSquare: HiMiniPencilSquare,
  hiMiniShieldCheck: HiMiniShieldCheck,
  history: FaHistory,
  hospital: FaHospital,
  imStatsBars2: ImStatsBars2,
  infoCircle: AiOutlineInfoCircle,
  listPatient: FaList,
  lockOutline: RiLockPasswordLine,
  logout: BiLogOut,
  logs: IoLogoBuffer,
  luHeartHandshake: LuHeartHandshake,
  magnifyingGlass: FaMagnifyingGlass,
  mdHealthAndSafety: MdHealthAndSafety,
  mdOutlineReadMore: MdOutlineReadMore,
  mdPregnantWoman: MdPregnantWoman,
  mic: FaMicrophoneAlt,
  network: LuNetwork,
  notCheck: BsXCircleFill,
  outlineCheck: FaRegCircleCheck,
  outlineSecurity: MdOutlineSecurity,
  pencil: FaPencilAlt,
  people: IoPeople,
  person: IoPerson,
  piNewspaperClippingBold: PiNewspaperClippingBold,
  piUploadBold: PiUploadBold,
  plus: FaPlus,
  pricetags: IoPricetags,
  powerBi: VscGraph,
  question: FaQuestion,
  questionCircle: FaRegQuestionCircle,
  releases: MdNewReleases,
  reload: IoReload,
  remove: IoMdRemoveCircleOutline,
  rename: BiRename,
  report: HiOutlineDocumentReport,
  riFileHistoryLine: RiFileHistoryLine,
  riUserFollowLine: RiUserFollowLine,
  save: FaSave,
  surveyFill: FaWpforms,
  table: FaTable,
  timeline: FaTimeline,
  towerControl: MdOutlineCellTower,
  trashFill: BsTrashFill,
  triangleSquareCircleFilled: TbTriangleSquareCircleFilled,
  uerFollowFill: RiUserFollowFill,
  uiChecks: BsUiChecks,
  undo: FaUndo,
  user: FiUser,
  userAddFill: RiUserAddFill,
  userAltSlash: FaUserAltSlash,
  userCheck: FaUserCheck,
  userEdit: FaUserEdit,
  userInjured: LiaUserInjuredSolid,
  usersGear: FaUsersGear
} as const;

export const ICON_SIZES = {
  XS: 14,
  S: 16,
  MD: 24,
  LG: 32,
  XL: 50
} as const;
